import {createReducer} from "redux-act";
import {IFanDraw, IFanDrawOption} from "apps/DRAW_PREDICTOR/modules/reducers";
import {setFanSentimentsQuestions, updateFanSentiment} from "apps/DRAW_PREDICTOR/modules/actions";

export interface IFanSentimentQuestions extends IFanDraw {
	answers: number[];
	playerOptionsArray?: IFanDrawOption[];
}

export interface IFanSentimentsReducer {
	questions: IFanSentimentQuestions[];
}

const initial: IFanSentimentsReducer = {
	questions: [],
};

export const fanSentiments = createReducer({}, initial)
	.on(setFanSentimentsQuestions, (state, payload) => ({
		questions: payload,
	}))
	.on(updateFanSentiment, (state, payload) => ({
		...state,
		questions: state.questions.map((question) => {
			if (question.id === payload.questionId) {
				return {
					...question,
					answers: question.answers.map((answer, index) => {
						return index === payload.answerIndex ? payload.optionId : answer;
					}),
				};
			}
			return question;
		}),
	}));
